import React, { Component } from 'react'
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import CKEditor from "react-ckeditor-component";
import { bindActionCreators } from 'redux';
import { AC_ADD_CATEGORY, AC_HANDLE_CATEGORY_CHANGE, AC_LIST_CATEGORY, AC_RESET_CATEGORY, AC_UPDATE_CATEGORY, AC_VIEW_CATEGORY, AC_EMPTY_CATEGORY, AC_LIST_CATEGORY_DRAG_DROP, AC_HANDLE_CATEGORY_SEARCH, AC_SPINNER_CATEGORY } from '../../actions/categoryAction';
import axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import ImportedURL from '../../common/api';
import { Error, Success } from '../../common/swal';
import Select from 'react-select';
import jsPDF from 'jspdf';
import Spinner from 'react-bootstrap/Spinner';
// import RLDD from 'react-list-drag-and-drop/lib/RLDD';

const initialState = {
    modalType: "Add",
    gridApi: '',
    columnDefs: [
        { headerName: '#', valueGetter: "node.rowIndex+1", width: 100, sortable: false, filter: false, headerClass: 'ag-center-header', cellStyle: { 'text-align': 'center' }, hide: 'true' },
        { headerName: 'Category', field: 'name', width: 300, floatingFilter: true, headerClass: 'ag-center-header' },
        {
            headerName: 'Status', width: 200, field: 'status', headerClass: 'ag-center-header', suppressMenu: true,
            cellRenderer: function (params) {
                if (params.data.status) {
                    return `<span type="button" class="tag tag-green active_status" data-action-type="Status">Active</span>`;
                } else if (!params.data.status) {
                    return '<span type="button" class="tag tag-danger inactive_status" data-action-type="Status">Inactive</span>';
                }
            }
        },
        {
            headerName: 'Action', width: 150, field: 'actions', cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true, sortable: false, filter: false,
            cellRenderer: function (params) {
                return params.value;
            }
        },
    ],
    defaultColumDef: {
        "width": 200,
        "filter": true,
        "sortable": true,
        "resizable": true
    },
    nameError: false,
    id: '',
    serachValue: '',
    pagination: 1,
    paginationLimit: 25,
    startLimit: 1,
    endLimit: 25,
}
class ListCategory extends Component {
    constructor(props) {
        super(props);
        this.state = initialState
    }
    changeModal = (e) => {
        this.props.EmptyCategory();
        this.setState({ modalType: e.target.id });
        this.props.ResetCategory();
    }
    onRowClicked = event => {
        this.setState({ spinner: false })
        const rowValue = event.event.target;
        const value = rowValue.getAttribute('data-action-type');
        if (value === 'View') {
            this.setState({ modalType: "View", nameError: false, id: event.data._id, });
        }
        if (value === 'Edit') {
            this.props.EmptyCategory();
            this.setState({ modalType: "Edit", id: event.data._id, nameError: false });
        }
        if (value === 'Status') {
            Swal.fire({
                title: 'Are you sure to change the status?',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Ok',
                imageUrl: '../../assets/images/status.png',
                customClass: {
                    popup: 'swal_pop',
                    title: 'swal_title',
                    image: 'swal_image',
                    actions: 'swal_action',
                    confirmButton: 'swal_confirm',
                    cancelButton: 'swal_close',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post(ImportedURL.API.statusChange, { id: event.data._id, status: !event.data.status, model: 'categories' })
                        .then((data) => {
                            this.props.ListCategory();
                            Success('Status updated successfully')
                        }).catch(({ response }) => {
                            if (response.status == 500) {
                                Error(response.status + ' Internal Server Error')
                            } else if (response.status == 502) {
                                Error(response.status + ' Bad Gateway')
                            } else {
                                Error(response.statusMessage)
                            }
                        });
                }
            })
        }
    }
    componentDidMount() {
        this.props.SpinnerCategory();
        this.props.EmptyCategory();
        this.props.ListCategory();
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    onGridReady = (params) => {
        this.gridColumnApi = params.columnApi;
        this.gridApi = params.api;
        this.gridApi.sizeColumnsToFit();
    }

    exportToCSV = () => {
        this.gridApi.exportDataAsCsv({
            columnKeys: ['name'],
            fileName: 'categorylist.csv',
            processCellCallback: function (params) {
                return params.value;
            }
        })
    }
    exportPDF = () => {
        const { CategoryState, AccountState } = this.props;
        const exportData = CategoryState.listcategories;
        const topHotelName = AccountState.account.hotelName;

        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";

        const marginLeft = 15;

        var img = new Image();
        img.src = '../../assets/images/logo.png';
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = topHotelName ? topHotelName + ' ' + '-' + ' ' + "Category List" : "Category List";
        if (topHotelName) {
            var headers = [['#', 'Category']];
            var data = exportData.map((elt, i) => [
                i + 1,
                elt.name,
            ]);
        } else {
            var headers = [['#', 'Category']];
            var data = exportData.map((elt, i) => [
                i + 1,
                elt.name,
            ]);
        };
        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                rowHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120);
        // doc.text('MyHotel AI', 710, 40)
        doc.autoTable(content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            doc.text('This is an auto-generated report from MyHotel AI (www.myhotelai.com) ', 20, 575);
        }
        doc.save("categorylist.pdf")
    }

    render() {
        if (this.state.modalType === "View") return <Redirect to={'view-category/' + this.state.id} />
        if (this.state.modalType === "Edit") return <Redirect to={'edit-category/' + this.state.id} />

        const { fixNavbar, CategoryState, AccountState } = this.props;
        const rowData = CategoryState.listcategories;
        const data = CategoryState.category;
        const spinner = CategoryState.spinner;
        const previleges = AccountState.previleges;
        const Previlege = previleges.find(obj => { return obj.name == "Category" });
        const editOption = (Previlege && Previlege.edit) ? '<button type="button" class="btn btn-icon" data-action-type="Edit"><i class="fa fa-edit" data-action-type="Edit"></i></button>' : '';
        const template = '<div><button type="button" class="btn btn-icon" data-action-type="View" ><i class="fa fa-eye" data-action-type="View"></i></button>'
            + editOption
            + '</div>'

        rowData.forEach(object => {
            object.actions = template;
        });
        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]
        return (
            <>
                <div>
                    <div>
                        <div class="content-header">
                            <div class="container-fluid">
                                <div class="row mb-2">
                                    <div class="col-12 breadcome_value">
                                        <ol class="breadcrumb ">
                                            <li class="breadcrumb-item header_color_breadcome"> <Link to='/admin'>Dasboard</Link></li>
                                            <li class="breadcrumb-item active">List Category</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container-fluid">
                            <div class="col-md-12">
                                <div class="card card-primary header_border" >
                                    <div class="table-title">
                                        <div className="card-header">
                                            <div className='rounded_icon'><i className="icon-bar-chart mr-2 "></i></div>
                                            <h3 className="card-title">List Category</h3>
                                            <div className="card-options">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <ul className="nav nav-tabs page-header-tab">
                                                    </ul>
                                                    <div className="header-action">
                                                        {(Previlege && Previlege.add) ? <Link to='/admin/add-category'><button type="button" className="btn btn-primary" data-toggle="modal" data-target="#exampleModal" id='Add' onClick={(e) => this.changeModal(e)}><i className="fe fe-plus mr-2" id='Add' />Add</button></Link> : ''}
                                                    </div>
                                                </div>
                                                {rowData.length > 0 ?
                                                    <>
                                                        <a className="btn btn-primary btn-sm nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2" aria-hidden="true"></i>Export</a>
                                                        <div className="dropdown-menu">
                                                            <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                            <a className="dropdown-item" type='button' onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                        </div>
                                                    </>
                                                    : []}
                                            </div>
                                        </div>
                                        <div className="card-body ">
                                            <div className="row">
                                                <div className="col-3">
                                                    <label for="exampleInputEmail1">Limit</label>
                                                    <div className="form-group">
                                                        <Select
                                                            onChange={(e) => this.gridApi.paginationSetPageSize(Number(e.value))}
                                                            options={limitOptions}
                                                            defaultValue={limitOptions[0]}
                                                            className='limit_size overall_select_option'
                                                            styles={{
                                                                menu: provided => ({ ...provided, zIndex: 9999, textAlign: 'left' })
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <div className="ag-theme-alpine">
                                                    <AgGridReact
                                                        rowHeight={75}
                                                        paginationPageSize={25}
                                                        pagination={true}
                                                        onRowClicked={this.onRowClicked}
                                                        domLayout={"autoHeight"}
                                                        defaultColDef={this.state.defaultColumDef}
                                                        rowData={rowData}
                                                        rowDragManaged={true}
                                                        animateRows={true}
                                                        columnDefs={this.state.columnDefs}
                                                        onGridReady={this.onGridReady}
                                                        overlayNoRowsTemplate={"No rows to display"}
                                                    >
                                                    </AgGridReact>
                                                </div>
                                                {/* {spinner ?
                                                                <div className='common_loader_ag_grid'>
                                                                    <img className='loader_img_style_common_ag_grid' src='../assets/images/logo.jpg' />
                                                                    <Spinner className='spinner_load_common_ag_grid' animation="border" variant="info" >
                                                                    </Spinner>
                                                                </div>
                                                                : ""} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </>
        )
    }
}
const mapStateToProps = state => ({
    fixNavbar: state.settings.isFixNavbar,
    CategoryState: state.category,
    AccountState: state.account,

})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        SpinnerCategory: AC_SPINNER_CATEGORY, searchCategoryList: AC_HANDLE_CATEGORY_SEARCH, CategoryDragDrop: AC_LIST_CATEGORY_DRAG_DROP, EmptyCategory: AC_EMPTY_CATEGORY, HandleInputChange: AC_HANDLE_CATEGORY_CHANGE, AddCategory: AC_ADD_CATEGORY, ListCategory: AC_LIST_CATEGORY, ViewCategory: AC_VIEW_CATEGORY, ResetCategory: AC_RESET_CATEGORY, UpdateCategory: AC_UPDATE_CATEGORY,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ListCategory);